import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { FormHelperText } from "@mui/material";

export default function InputRadio(props) {
  const {
    name,
    label,
    value,
    variant,
    onChange,
    error = null,
    options,
    row = true,
    ...other
  } = props;

  return (
    <FormControl data-field={name} {...other}>
      <FormLabel id={name} className="text-gray-700">
        {label}
      </FormLabel>
      <RadioGroup row={row} aria-labelledby={name} name={name} value={value}>
        {options.map((item, i) => (
          <FormControlLabel
            key={i}
            value={item.id}
            onChange={onChange}
            control={<Radio />}
            label={item.label}
            className="text-gray-500"
          />
        ))}
      </RadioGroup>
      {error && (
        <FormHelperText sx={{ color: "#d32f2f" }}>{error}</FormHelperText>
      )}
    </FormControl>
  );
}
